import React from 'react';
const noMore = ['No more rebuilding every lecture and lab session from scratch.', 'No more hours searching scattered textbooks, slides and videos.', 'No more explaining anatomy, procedures and materials with words alone.', 'No more students memorizing steps without understanding why.', 'No more simulation labs without clear visual material.', 'No more repeating the same corrections every week.', 'No more assessing competencies without clear criteria.', 'No more losing time you could spend actually teaching.'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-[#0F4C5C] relative overflow-hidden" data-id="element-125" data-mp="vurukptgxbh7">
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-126" data-mp="vwujf6ivwykc">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-8 leading-tight text-white uppercase" data-id="element-127" data-mp="qwzu37erch1e">
          Next Month You Can Still Be Searching for Dental Teaching Material...
          <br data-id="element-128" data-mp="zxeg68zjq05y" />
          <span className="text-[#8FDCD7]" data-id="element-129" data-mp="zxxznu4ugwm3">
            Or You Can Have a Complete Visual Training System Ready for Your Next Session.
          </span>
        </h2>
        <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white p-8 rounded-2xl border border-[#8FDCD7]/60" data-id="element-130" data-mp="2h37zx4tb4x29">
          {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-131" data-mp="2m4x729desql2">
              <span className="text-[#0B7A7A] mt-0.5" aria-hidden="true" data-id="element-132" data-mp="2r2ozd4hyueps">
                ▸
              </span>
              <span className="text-slate-700" data-id="element-133" data-mp="2v2zf38vk8jhu">{item}</span>
            </div>)}
        </div>
        <p className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-134" data-mp="300sn87gfbnkr">
          DENTAL INSTRUCTOR ATLAS doesn&apos;t replace your clinical experience, an accredited dental curriculum or
          your institution&apos;s clinical protocols.
        </p>
        <p className="text-xl text-white/80 mb-6" data-id="element-135" data-mp="3es1iaw33i15a">
          It supports your teaching with a structured visual system designed to give you more:
        </p>
        <p className="text-lg md:text-2xl font-extrabold tracking-widest text-[#8FDCD7]" data-id="element-136" data-mp="3ir0loc96hpum">
          CLARITY · STRUCTURE · CONSISTENCY · CONFIDENCE
        </p>
      </div>
    </section>;
}